/**
 * Returns a locale code that can be used when fetching data from Depict.
 */
export const getDepictLangCode = (languageCode: string) => {
    const mapping: Record<string, string> = {
        de: "de_DE",
        en: "en_GB",
        fr: "fr_FR",
        ja: "ja_JP"
    }

    return mapping[languageCode.toLowerCase()] || mapping.en
}
